<div class="container-fluid" style="padding-left: 10px;">
    <div class="row ">
        <!-- Header -->
        <div class="col-12 col-md-12 bgWhite padHeder mobView" style="padding-bottom: 0px;">
            <div class="col-6 col-md-6 pad0" style="display: inline-block;vertical-align: sub;">
            <span style="font-size: 20px; margin-right: 10px;" (click)="backBtn()">
                <i class="fa fa-chevron-left"></i>
            </span>
            <h4 class="newHeader" style="display: inline-block; font-size: 30px;">Settings</h4>
            </div> 
             
        </div>
       
        <div class="col-12 col-sm-12 bgWhite webView"  style="padding: 15px 15px 15px 30px">
            <h3 style="display: inline-block;" class="newHeader">
                Settings
            </h3>
            <span class="btn-blue brdrRadius3" style="font-size: 13px;padding: 4px 12px 4px; float: right;" (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 3px; vertical-align: middle;"></i> {{prTypeID == 2 ? 'Return to Projects' : 'Return to Production'}}
            </span>
        </div>
       
        <!-- settings List -->
        <div class="col-md-12 col-12 col-sm-12 leftPad">
            <!-- Stages -->
            <div *ngIf="prTypeID == 1" class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div [routerLink]="['/StageConfig']" class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Process Stages</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Configure production stages for efficient workflow management.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Stage Flow -->
            <div *ngIf="prTypeID == 1" class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="openMdl(stageFlowMdl, 'stageFlow')">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Process Flows</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Set the sequence of stages in the production process.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Project Types -->
            <div *ngIf="prTypeID == 2" class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" [routerLink]="['/ProjectTypes']">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Project Types</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Configure different types of projects.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Rejection Reasons -->
            <div *ngIf="prTypeID == 1" class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" [routerLink]="['/RejectionReasons']">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Rejection Reasons</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Define specific reasons for rejecting a production item.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Expense Types -->
            <div *ngIf="prTypeID == 2" class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" [routerLink]="['/ExpenseConfig']">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Expense Types</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Define various expense categories within a project for accurate tracking.</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Print Cofiguration -->
            <div *ngIf="prTypeID == 1" class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="openPrntCnfgMdl('prntCnfgMdl')">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Job Card Print Configuration</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Customize print configurations for production documentation.</p>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
     </div>
</div>

<!--Add Stage Flow-->
<ng-template #stageFlowMdl let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none; padding-bottom: 20px;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row" style="display: flex; justify-content: space-between;">
                <h4 class="modal-title" style="font-size: 22px;"><span id="ApntmntHdr">Stage Flows</span></h4>
                <div class="pad0" style="display: flex; flex-wrap: wrap; align-items: center; justify-content: end;">
                    <span class="btn-darkGreen brdrRadius3" (click)="openAddStageFlow(AddStageFlowMdl, 0)"
                        style="padding: 4px 8px !important; line-height: 17px; vertical-align: center !important; margin-right: 5px;background-color: #e88421; border-color: #e88421 !important; font-size: 14px;">
                        <i class="zmdi zmdi-plus" aria-hidden="true"></i> Add
                    </span>                   
                    <i class="closeMdl zmdi zmdi-close" style="float: right; margin: 0px; top: 0px;"
                        (click)="closeModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12 col-12 col-sm-12" style="padding: 0px 15px 15px 15px;">
            <!-- Stage List -->
            <div *ngIf="stgFlowList.length > 0" class="col-md-12 col-12 col-sm-12 pad0 marginTp"
                style="margin-bottom: 15px;">
                <!-- <div class="label-new" style="color: #333; font-size: 12px;">Current Stage Flows:</div> -->
                <div style="max-height: 200px; overflow-y: auto;">
                    <div mat-cell *ngFor="let s of stgFlowList; let i = index"
                        style="{{ i % 2 == 0 ? 'background-color: #f5f5f5;' : 'background-color: #fff;' }}">
                        <div class="col-md-12 col-12 col-sm-12 pad0"
                            style="display: flex; justify-content: space-between; align-items: center; padding: 5px 15px;">
                            <div class="col-md-9 col-9 col-sm-9 pad0 inLneBlk" style="font-size: 14px;">
                                <span>{{s.StageFlow}}</span>
                            </div>
                            <div class="col-md-1 col-1 col-sm-1 pad0 inLneBlk txtRight" (click)="editStageFlow(AddStageFlowMdl, i)">
                                <span class="lableBtnOrange height30 brdrRadius3" title="Edit Stage Flow Details"
                                    style="padding: 2px 7px 2px; "><i class="fa fa-pencil"></i></span>
                            </div>
                            <div class="col-md-1 col-1 col-sm-1 pad0 inLneBlk txtRight" (click)="removeStageFlow(i)">
                                <span class="lableBtnGray brdrRadius3" title="Remove Stage Flow"
                                    style="padding: 2px 7px 2px;"><i class="fa fa-trash-o"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="stgFlowList.length == 0">
                <div class="nrf brdrRadius3 mt-2" style="cursor: pointer;" (click)="openAddStageFlow(AddStageFlowMdl, 0)">
                    Click here to add a stage to your process flow.
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #AddStageFlowMdl let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row" style="display: flex; justify-content: space-between;">
                <h4 class="modal-title" style="font-size: 22px;"><span id="ApntmntHdr">Stage Flow Configuration</span></h4>
                <div class="pad0" style="display: flex; flex-wrap: wrap; align-items: center; justify-content: end;">
                
                    <i class="closeMdl zmdi zmdi-close" style="float: right; margin: 0px; top: 0px;"
                        (click)="closeStageModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">  
        <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 18px 18px 18px;">
            <div class="row m-0 p-0" style="display: flex !important; align-items: center !important;">
                <div class="label-new col-md-3 col-sm-3 col-xs-3 col-12 d-flex align-items-center" style="color: #333; font-size: 12px; ">
                    Flow Name <span class="smDsply">:</span>
                    <span class="redText margTop10">*</span>
                </div>
                <div class="col-md-9 col-sm-9 col-xs-9 col-12 m-0 p-0">
                    <input type="text" class="form-control form-control-input" [(ngModel)]="stgFlowName" tabindex="1"
                        capitalize-first maxlength="100" placeholder="Enter Flow Name">
                </div>        
            </div>
        
            <div>
                <div class="row m-0 p-0" style="margin-top: 15px !important;">
                    <div class="col-12 col-md-3 col-sm-3 col-xs-3 d-flex align-items-center m-0 p-0">
                        <div class="label-new" style="color: #333; font-size: 12px;">
                            Stage <span class="smDsply">:</span>
                            <span class="redText margTop10">*</span>
                        </div>
                    </div>
                    <!-- All Stages -->
                    <div class="col-12 col-md-9 col-sm-9 col-xs-9 m-0 p-0">
                        <select class="form-control form-control-input" (change)="addNewStage($event)" style="font-size: 13px;">
                            <option value="" selected>Select</option>
                            <option *ngFor="let s of stageList" [ngValue]="s.SNm">{{s.SNm}}</option>
                        </select>
                    </div>
                </div>
        
                <!-- Stage List -->
                <div class="col-md-12 col-12 col-sm-12 pad0 mt-3" style="margin-bottom: 15px;">
                    <div class="marginTp" *ngIf="newStageList.length > 0">
                        <div cdkDropList id="divScrID" (cdkDropListDropped)="drop($event)"
                            style="max-height: 200px; overflow-y: auto;">
                            <div *ngFor="let s of newStageList; let i = index"
                                style="cursor: pointer; {{ i % 2 == 0 ? 'background-color: #f5f5f5;' : 'background-color: #fff;' }}"
                                cdkDrag>
                                <div class="col-md-12 col-12 col-sm-12 pad0"
                                    style="display: flex; justify-content: space-between; align-items: center; padding: 5px 15px;">
                                    <div class="col-md-9 col-9 col-sm-9 pad0 inLneBlk" style="font-size: 14px;">
                                        <span> {{s.SNm}}</span>
                                    </div>
                                    <div class="col-md-1 col-1 col-sm-1 pad0 inLneBlk txtRight"
                                        style="display: inline-block; cursor: pointer;text-align: center; color: grey;"
                                        title="Rearrange Stage" (cdkDropListDropped)="drop($event)">
                                        <span class="brdrRadius3" style="color: #e88421;" title="Remove Stage">
                                            <i class="fa fa-bars"></i>
                                        </span>
                                    </div>
                                    <div class="col-md-1 col-1 col-sm-1 pad0 inLneBlk txtRight"
                                        (click)="removeStage(i)">
                                        <span class="lableBtnGray brdrRadius3" title="Remove Stage"
                                            style="padding: 2px 7px 2px;"><i class="fa fa-trash-o"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <span class="btn-darkGreen ng-scope brdrRadius3 btn-save"
                        style="padding: 2px 7px 1px; height: 30px; font-size: 14px;" (click)="saveStageFlow()">
                        <i class="fa fa-check" style="margin-right: 5px;"></i>Save
                    </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!--Add stage-->
<ng-template #prntCnfgMdl let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none; padding-bottom: 5px !important;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title" style="line-height: 1.2;">
                        <span style="font-size: 22px;">Job Card Print Configuration</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close " title="Close" style="float: right; margin-top: 0px;" (click)="closePrntCnfModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12 col-12 col-sm-12 font13" style="padding: 4px 15px 0px; margin-bottom: 0px;">
            <div>
                <mat-checkbox class="example-margin" [(ngModel)]="prtCnfg.jobInst" tabindex="1">Instructions
                </mat-checkbox>
            </div>
            <div>
                <mat-checkbox class="example-margin" [(ngModel)]="prtCnfg.itemDesc" tabindex="2">Item Description</mat-checkbox>
            </div>
        </div> 
        <div class="col-md-12 col-xs-12 col-12" style="display: flex; padding: 5px 0px 15px 15px;">
            <div (click)="savePrntCnfg()">
                <span class="btn-save brdrRadius3" style="font-size: 14px !important; top: 1px;border-radius:25px;">
                    <i class="fa fa-check " style="margin-right:8px;"></i> Save 
                </span>
            </div>
        </div>
    </div>
</ng-template>